import { ArchiveRestoreRequestMsg } from '../../autogenerated/ZoomBridge';

export function createNewArchiveRestoreWebRequestMessage(
  bid,
  fuidSet,
  requestIdPrefix,
  hiResStatus,
  midResStatus,
  lowResStatus,
  directStatus,
  storageType,
  location,
  keepSource
) {
  const archiveWebRequestMessage = new ArchiveRestoreRequestMsg();
  archiveWebRequestMessage.setBid(bid);
  archiveWebRequestMessage.setFuids(fuidSet);
  archiveWebRequestMessage.setRequestId(requestIdPrefix + '-' + getUUID()); //UUID flex uses current time only. So no need to add any time.
  archiveWebRequestMessage.setRequestType(requestIdPrefix);

  if (hiResStatus || midResStatus || lowResStatus || directStatus) {
    const storageTypeStr = 'storage-type=' + (storageType == null ? '' : storageType);
    const locationStr = 'location=' + location;
    const keepSourceStr = 'keepSource=' + (keepSource ? 'true' : 'false');
    let resolution =
      'resolutions=' +
      (hiResStatus ? 'HR,' : '') +
      (midResStatus ? 'MR,' : '') +
      (lowResStatus ? 'LR,' : '') +
      (directStatus ? 'Direct' : '');
    resolution =
      resolution.lastIndexOf(',') + 1 == resolution.length
        ? resolution.substring(0, resolution.length - 1)
        : resolution;
    archiveWebRequestMessage.setExtraData(locationStr + ';' + storageTypeStr + ';' + resolution + ';' + keepSourceStr);
  }
  return archiveWebRequestMessage;
}

export function getUUID() {
  return (
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)
  );
}
